import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-registration-content-header",
  templateUrl: "./registrationContentHeader.component.html",
  styleUrls: ['./registrationContentHeader.component.scss']
})
export class RegistrationContentHeader implements OnInit {
  constructor(private router: Router) {}

  @Input() step: string;

  headerText: string;
  subHeaderText: string;

  ngOnInit(): void {
    this.headerText = `Pages.RegistrationByPhone.Step${this.step}.HeaderText`;
    this.subHeaderText = `Pages.RegistrationByPhone.Step${this.step}.SubHeaderText`;
  }
}
